var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { CheckmarkIcon } from '@move-ui/icons-asset-catalog';
import { mergeRefs } from '@move-web-essentials-utils/ref';
import styles from './Checkbox.module.css';
export const Checkbox = (_a) => {
    var { className, checked, indeterminate, label, id, name, isValid = true, disabled, errorMessage, inputRef, labelPosition = 'right', fullWidth, description } = _a, rest = __rest(_a, ["className", "checked", "indeterminate", "label", "id", "name", "isValid", "disabled", "errorMessage", "inputRef", "labelPosition", "fullWidth", "description"]);
    const uniqId = id || name;
    const showError = !(isValid || disabled);
    const isChecked = checked && !indeterminate;
    const isIndeterminate = indeterminate && !disabled;
    const behaviors = {
        [styles.checked]: isChecked,
        [styles.error]: showError,
        [styles.disabled]: disabled,
        [styles.indeterminate]: isIndeterminate
    };
    const checkboxRef = useRef(null);
    useEffect(() => {
        import('focus-visible').catch(() => null);
    }, []);
    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = !!indeterminate;
        }
    }, [indeterminate, checkboxRef]);
    return (React.createElement("label", { htmlFor: uniqId, className: cx(styles.label, className) },
        React.createElement("input", Object.assign({ id: uniqId, className: cx(styles.input, {
                [styles.right]: labelPosition === 'left'
            }), type: "checkbox", checked: checked, name: name, "aria-invalid": !isValid, disabled: disabled, ref: mergeRefs(checkboxRef, inputRef) }, (showError && { 'aria-errormessage': `${uniqId}-errorMessage` }), rest)),
        React.createElement("span", { className: cx(styles.checkbox, behaviors, {
                [styles.withMargin]: label,
                [styles.fullWidth]: fullWidth,
                [styles.right]: labelPosition === 'left'
            }) },
            isChecked && (React.createElement(CheckmarkIcon, { fillColor: "#FFFFFF", className: styles.checkmark })),
            isIndeterminate && (React.createElement("div", { "data-testid": "indeterminate", className: styles.indeterminateSquare }))),
        label && (React.createElement("span", { className: cx(styles.labelText, {
                [styles.disabled]: disabled,
                [styles.error]: !isValid,
                [styles.checked]: isChecked
            }) },
            typeof label === 'function' &&
                label({
                    isValid,
                    disabled,
                    checked: isChecked
                }),
            typeof label !== 'function' && label)),
        description && React.createElement("span", { className: styles.description }, description),
        showError && errorMessage && (React.createElement("span", { id: `${uniqId}-errorMessage`, className: styles.errorMessage }, errorMessage))));
};
//# sourceMappingURL=Checkbox.js.map